const nestedProperty = (obj, ...args) => {
  const currentValue = args.reduce((thing, property) => thing && thing[property], obj);
  return currentValue || null;
};

// eslint-disable-next-line import/prefer-default-export
export { nestedProperty };
